import MonetateService from '~/services/monetate.service';
import type { OrderSingleResponse } from '~/types/ecom/order.type';
import type { Product } from '~/types/ecom/product/product.type';
import type { ActionItems, TrolleyActions, TrolleyLineItem } from '~/types/monetate/monetate.type';

export const useMonetateStore = defineStore({
  id: 'MonetateStore',
  state: () => ({
    // builder
    builder_recommendations_id: [] as string[],
    builder_component: 'you-may-also-like',
    builder_page_type: 'trolley' as string,
    monetate_item_add_ons: [] as Product[],

    // trolley_pop_up
    trolley_pop_up_recommendations: <ActionItems>{},

    // Thank you page
    order_confirmation_recommendations: <ActionItems>{},

    // pdp
    pdp_everything_for_your_job: <ActionItems>{},
    pdp_others_also_looked_at: <ActionItems>{},
    pdp_similar_item: <ActionItems>{},

    // search page
    search_recommendations: <ActionItems>{},

    // category detail page
    category_detail_best_seller: <ActionItems>{},
    category_detail_top_seller: <ActionItems>{},

    // plp - purchased and also purcchased
    plp_recommendaions: <ActionItems>{},

    //trolley page cart
    trolley_page_recommendations: <TrolleyActions>{},

    //  Account Page
    account_page_recommendations: <ActionItems>{},

    // Faq Page
    faq_page_recommendations: <ActionItems>{},

    // Social Proof
    social_proof_data: <string>'',
  }),

  actions: {
    /**
     * Handles the impression event when a product is clicked.
     * @param productId - ID of the clicked product
     */

    // Add to cart event

    async addToCartEvent(lineItems: TrolleyLineItem) {
      const runtimeconfig = useRuntimeConfig();
      const appRegion = runtimeconfig.public.appRegion;
      await new MonetateService().addToCartEvent(appRegion, lineItems);
    },

    // purchase event

    async purchaseEvent(order: OrderSingleResponse) {
      const runtimeconfig = useRuntimeConfig();
      const appRegion = runtimeconfig.public.appRegion;
      const { purchaseEvent } = await import('~/stores-datalayer/monetate.datalayer');
      return await purchaseEvent(appRegion, order);
    },

    // async trackPlpView(){
    //   const { trackPlpView } = await import('~/stores-datalayer/monetate.datalayer');
    //   return await trackPlpView();
    // },

    async trackRecommendationClick(appRegion: string, state: ActionItems, id: string) {
      const { trackRecommendationClick } = await import('~/stores-datalayer/monetate.datalayer');
      return await trackRecommendationClick(appRegion, state, id);
    },

    async getproductFromId() {
      const { getproductFromId } = await import('~/stores-datalayer/monetate.datalayer');
      return await getproductFromId();
    },
  },
});
